import React from 'react';
import PropTypes from 'prop-types';
import './Slide.scss';

const Slide = ({ quote, citation }) => (
  <div className="container-guttered">
    <blockquote className="video-background-slider-blockquote">
      {quote}
      <cite className="video-background-slider-cite">{citation}</cite>
    </blockquote>
  </div>
);

Slide.propTypes = {
  quote: PropTypes.string.isRequired,
  citation: PropTypes.string.isRequired,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/client/js/view/components/VideoBackgroundSlider/Slide.js